<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header.bg-info.text-white
				span.fa.fa-money.mr-2
				| Pago de comisiones
				button.close(@click="cerrar") &times;
			.card-body
				.form-group
					label
						b Agente
					input-query(
						:realtime="true"
						url="/facturacion-cobros/php/api/buscaAgentes.php"
						@selected="seleccionaAgente($event)"
						v-if="!datos.AgenteID && editable"
						input-class="form-control"
					)
					div.input-group(v-else)
						input.form-control(disabled, :value="datos.AgenteNombre")
						.input-group-append(v-if="editable")
							button.btn.btn-danger(@click="quitarAgente")
								span.fa.fa-trash

			table.table.table-striped(v-if="comisionesPendientes !== null && comisionesPendientes.length > 0")
				thead
					tr
						th Fecha
						th Comisión
						th.text-right
							input(type="checkbox", @click="seleccionaTodos($event)", ref="todasComisiones")
				tbody
					tr(
						v-for="comision in comisionesPendientes"
						:key="comision.ComisionID"
						@click="toggleComision(comision, $event)"
						style="cursor: pointer;"
					)
						td {{comision.FechaGenerada | moment('DD-MM-YYYY')}}
						td {{comision.ImporteComision | currency('')}} €
						td.text-right
							input(type="checkbox", @click="toggleComision(comision, $event)", :checked="datos.ComisionesID.indexOf(comision.ComisionID) >= 0")
			.card-body.bg-light(v-if="datos.ComisionesID.length > 0")
				h2.text-danger
					b Importe: {{importePago | currency('')}} €
			.card-body
				.form-group
					label
						b Fecha
					datepicker(
						v-model="datos.FechaPagado"
						:monday-first="true"
						:bootstrap-styling="true"
						:language="$dateLang"
						inputClass="form-control"
						v-if="editable"
					)
					div(v-else) {{datos.FechaPagado | moment('DD-MM-YYYY')}} a las {{datos.FechaPagado | moment('HH:mm:ss')}}

			.card-body.bg-dark.text-white
				.form-group
					label
						b Usuario responsable
					h3 {{datos.UsuarioNombre}}
			.card-footer(v-if="editable")
				button.btn.btn-primary(@click="pagar")
					span.fa.fa-check.mr-2
					| Pagar
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['ComisionID'],
	data () {
		return {
			datos: {
				PagoID: null,
				AgenteID: null,
				AgenteNombre: null,
				FechaPagado: new Date(),
				UsuarioID: null,
				UsuarioNombre: null,
				ComisionesID: []
			},
			comisionesPendientes: null
		}
	},
	created () {
		if (this.ComisionID && this.ComisionID !== 'nueva') {
			this.getComision()
		} else {
			this.datos.ComisionID = 'nueva'
			this.datos.UsuarioID = this.usuario.ID
			this.datos.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos
		}
	},
	computed: {
		...mapGetters({
			'usuario': 'session/usuario'
		}),
		importePago () {
			if (this.comisionesPendientes === null) {
				return 0
			}

			return this.comisionesPendientes.reduce((ant, actual) => {
				if (this.datos.ComisionesID.indexOf(actual.ComisionID) >= 0) {
					ant = ant + actual.ImporteComision
				}
				return ant
			}, 0)
		},
		formValido () {
			if (!this.datos.AgenteID) {
				return false
			}

			if (!this.datos.Importe) {
				return false
			}

			if (!this.datos.FechaPagado) {
				return false
			}

			return true
		},
		editable () {
			return (this.datos.ComisionID === 'nueva')
		}
	},
	methods: {
		getComision () {
			this.$http.post('facturacion-cobros/php/api/comisiones/getComision.php', {ComisionID: this.ComisionID})
				.then(res => {
					this.datos = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		seleccionaAgente (ev) {
			this.datos.AgenteID = ev.datos.ID
			this.datos.AgenteNombre = ev.datos.nombre + ' ' + ev.datos.apellidos

			this.$http.post('facturacion-cobros/php/api/comisiones/getComisionesPendientesAgente.php', {AgenteID: ev.datos.ID})
				.then(res => {
					this.comisionesPendientes = res.data
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		quitarAgente () {
			this.datos.AgenteID = null
			this.datos.AgenteNombre = null
			this.comisionesPendientes = []
		},
		seleccionaTodos (ev) {
			const checked = ev.srcElement.checked

			if (checked) {
				this.datos.ComisionesID = this.comisionesPendientes.map(c => c.ComisionID)
			} else {
				this.datos.ComisionesID = []
			}
		},
		toggleComision (comision, ev) {
			ev.stopPropagation()
			// ev.preventDefault()
			const idx = this.datos.ComisionesID.indexOf(comision.ComisionID)

			if (idx >= 0) {
				this.datos.ComisionesID.splice(idx, 1)
			} else {
				this.datos.ComisionesID.push(comision.ComisionID)
			}

			if (this.datos.ComisionesID.length !== this.comisionesPendientes.length) {
				this.$refs.todasComisiones.checked = false
			} else {
				this.$refs.todasComisiones.checked = true
			}
		},
		pagar () {
			const form = {
				ComisionesID: this.datos.ComisionesID
			}

			this.$http.post('facturacion-cobros/php/api/comisiones/pagarComision.php', form)
				.then(res => {
					this.$emit('actualizar')
					this.cerrar()
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/comisiones/editarPago.vue